export default __webpack_public_path__ + "static/media/Sport Future Bass.64a763df.mp3";